import React from 'react';

import styles from './BengkelBanner.module.scss';
import { GTM_CLASS } from '../../../lib/constant';

const BengkelBanner = () => {
  return (
    <div className={styles.BengkelBanner}>
      <div className={styles.BengkelBanner__image}>
        <img
          src={`/media/static/images/banner-bengkel.png`}
          alt="Pesan Bengkel"
          width={364}
          height={143}
        />
      </div>
      <div className={styles.BengkelBanner__button}>
        <a href={`/bengkel-mobil/`} title="Pesan Bengkel" className={GTM_CLASS.REDIRECTION_BENGKEL}>
          Pesan Bengkel
        </a>
      </div>
    </div>
  );
};

export default BengkelBanner;
